import React, { useEffect } from 'react';

const QuantumPage = () => {
  useEffect(() => {
    // Redirect to LSD mode HTML page
    window.location.href = '/lsd.html';
  }, []);

  return null;
};

export default QuantumPage;
